import React from 'react'

import './checkbox.scss'

export default props => {

  const {
    label,
    checked,
    disabled,
    type,
    onChange,
  } = props

  return (
    <label className="checkbox-container">{label}
      <input type="checkbox" checked={checked} onChange={e => onChange(e, type)} disabled={disabled}/>
      <span className="checkbox-checkmark"/>
    </label> 
  )
}
